import { getAmplitudeInstance } from '../amplitudeHelpers';
import PostSignUpScreenCta from '../enums/PostSignUpScreenCta';

type logPostSignUpScreenCtaClickedParams = {
  cta: PostSignUpScreenCta;
};

/**
 * User taps a CTA on the getting started welcome screen.
 * @param params - Attributes to log with the amplitude event
 * @param params.cta - Which CTA was tapped.
 */
const logPostSignUpScreenCtaClicked = ({ cta }: logPostSignUpScreenCtaClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('post sign up screen cta clicked', { cta }, callback);
};

export default logPostSignUpScreenCtaClicked;
